import React from "react";
import { Stack, Typography } from "@mui/material";

const InfoCard = ({
  title,
  description,
  icon: IconComponent, 
  sx = {},
}) => {
  return (
    <Stack
      sx={{
        height: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
        width: { xl: "30%", lg: "30%", md: "30%", sm: "30%" },
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        background: "linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))", // Gradient for glass effect
        backdropFilter: "blur(10px)", // Blur for glassmorphism
        WebkitBackdropFilter: "blur(10px)", 
        borderRadius: "12px", 
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)", // Shadow for depth
        padding: "1rem", 
        gap: "1rem", // Space between icon and text
        transition: "all 0.3s ease", // Smooth hover effect
        "&:hover": {
          background: "linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.1))", // Brighter gradient on hover
          boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.2)", 
        },
        ...sx,
      }}
    >
      {/* Icon Section with Nested Glassmorphism */}
      <Stack
        sx={{
          height: "60px", 
          width: "60px",
          borderRadius: "8px", 
          border: "1px solid rgba(255, 255, 255, 0.15)", // Subtle border
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // Nested glassmorphism effect for the icon container
          background: "linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03))", // Subtle gradient
          backdropFilter: "blur(6px)", // Slightly less blur than the parent
          WebkitBackdropFilter: "blur(6px)", // Safari support
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
        }}
      >
        {IconComponent && (
          <IconComponent
            sx={{
              fontSize: "40px", 
              color: "rgba(255, 255, 255, 0.9)", // White with slight opacity for contrast
            }}
          />
        )}
      </Stack>

      {/* Title and Description */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            // border: "1px solid red",
            color: "#fff", 
            fontSize: "18px", 
            fontWeight: "550", 
             fontFamily: "'Roboto', sans-serif",
            // textTransform: "uppercase", // Matches the uppercase style in the image
            letterSpacing: "0.5px", // Adds slight spacing for better readability
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.9)", 
            fontSize: "16px", 
            fontWeight: "400", 
            fontFamily: "'Roboto', sans-serif",
          }}
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default InfoCard;